import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareTimelineCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-timeline-custom-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/timeline/:viewId/embed',
	exact: true,
};
